module.exports = __webpack_public_path__ + "static/Xanatos-2339886328c212682cb6da3bbd08f959.png";